// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-SivShX9q"};